/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type ColumnType = (typeof ColumnType)[keyof typeof ColumnType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ColumnType = {
    None: 'None',
    Numeric: 'Numeric',
    Text: 'Text',
} as const;
